import { Button, Grid2 } from '@mui/material';
import { useProductList } from '../../../assets/api/useProTeacherApi';
import SkillBoxProductCard from '../../../shared/components/SkillBoxProductCard';
import { NormalContainerWithHeader } from '../../../shared/components/student/NormalComponent';
import { SkeletonCom } from '../../../shared/utils/SkeletonCom';

const ProTeacherProductList = () => {
    const {
        data: product,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading: isProductLoading
    } = useProductList();
    const productList = product?.pages?.flatMap((page) => page?.data) || [];
    return (
        <NormalContainerWithHeader headerText={"Skill Box Courses"}>
            <Grid2 container spacing={"2rem"}>
                {!isProductLoading &&
                    productList?.map((item, index) => (
                        <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
                            <SkillBoxProductCard item={item} key={index} />
                        </Grid2>
                    ))
                }
                {isProductLoading &&
                    [...Array(6)]?.map((item, index) => (
                        <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
                            <SkeletonCom key={index} />
                        </Grid2>
                    ))
                }

                {
                    hasNextPage && (<Grid2 size={12} sx={{ display: "flex", justifyContent: "center" }}>
                      

                        <Button variant='outlined'
                            onClick={() => fetchNextPage()}
                        >{isFetchingNextPage ? 'Loading...' : 'View More'}</Button>
                    </Grid2>

                    )
                }

            </Grid2>
        </NormalContainerWithHeader>
    )
}

export default ProTeacherProductList
